import { Outlet, createFileRoute } from '@tanstack/react-router'
import ManageUsers from '../../../containers/ManageUsers'
import RequirePermission from '../../../containers/authentication/components/require-permission'
import { useOrganizationalAccess } from '../../../hooks/use-organizational-access'
import { userManagementSearchSchema } from './search-schemas'

export const Route = createFileRoute('/_authenticated/userManagement')({
  validateSearch: userManagementSearchSchema,
  component: UserManagementLayout
})

function UserManagementLayout() {
  const search = Route.useSearch()
  const { isResolved, canSeeUserManagement } = useOrganizationalAccess()

  return (
    <RequirePermission allowed={canSeeUserManagement} isResolved={isResolved}>
      {search.manage === 'users' && <ManageUsers searchParams={search} />}
      <Outlet />
    </RequirePermission>
  )
}
